import { useRef } from "react";
import { useAppDispatch } from "../../state/hooks";
import { closeConfirmationModal } from "../../state/slice/modal/modalSlice";
import ModalStandard from "./ModalStandard";
import { IsLoading, useLoading } from "../AppState/IsLoading";
import { LoadingState } from "../../state/slice/appStateSlice";
import { t } from "i18next";

type ModalConfirmationProps = {
  title: string;
  text?: string;
  text2?: string;
  submitButtonText?: string;
  onClickSubmit: () => void;
  onClickCancel?: () => void;
  id: string;
  componentId?: string;
  children?: React.ReactNode;
  isMediaList?: boolean;
  danger?: boolean;
};

const ModalConfirmation = ({
  id,
  title,
  text = "",
  text2 = "",
  componentId,
  onClickSubmit,
  onClickCancel = () => {},
  children,
  submitButtonText,
  isMediaList = false,
  danger = false,
}: ModalConfirmationProps) => {
  const dispatch = useAppDispatch();
  const submitRef = useRef<HTMLElement | null>(null);
  const isSubmitting = useLoading(componentId ?? "") === LoadingState.Loading;

  return (
    <ModalStandard id={id} fullScreen={false} modalType={"confirmation"} initialFocus={submitRef}>
      <div className="modalContent personalize-scroll-visible">
        {componentId && (
          <div className="z-20">
            <IsLoading componentId={componentId} showSuccess={false} />
          </div>
        )}
        <div>
          <p className={`${isMediaList ? "font-bold text-2xl mx-5" : "font-medium text-lg"} my-4`}>
            {title}
          </p>
          <p className="text-gray-600 mb-4">{text}</p>
          {text2 && <p className="text-gray-600 mb-4">{text2}</p>}
          <div>{children}</div>
        </div>
      </div>

      <div className="flex justify-end mt-1">
        <button
          type="button"
          className="btn-alternative-outline mr-4"
          onClick={() => {
            dispatch(closeConfirmationModal(id));
            if (onClickCancel) onClickCancel();
          }}
        >
          {String(t("general.cancel"))}
        </button>
        <button
          ref={submitRef as React.RefObject<HTMLButtonElement>}
          className={danger ? "btn-danger-fill" : "btn-primary-fill"}
          type="button"
          disabled={isSubmitting}
          onClick={onClickSubmit}
        >
          {submitButtonText ? submitButtonText : String(t("general.yes"))}
        </button>
      </div>
    </ModalStandard>
  );
};

export default ModalConfirmation;
